"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Mary S.",
  quote: "Nieser Landscaping transformed our backyard into a beautiful retreat. Their 40 years of expertise really shows!",
  position: "Homeowner",
  neighborhood: "Plum Borough"
}, {
  author: "Robert T.",
  quote: "The most reliable lawn maintenance crew in Pittsburgh. They treat our yard like it's their own every single week.",
  position: "Property Owner",
  neighborhood: "Murrysville"
}, {
  author: "Linda G.",
  quote: "Professional, punctual, and the new retaining wall is stunning. They handled the slope of our yard perfectly.",
  position: "Homeowner",
  neighborhood: "Penn Hills"
}, {
  author: "James W.",
  quote: "From the initial estimate to the final cleanup, the team was exceptional. Our curb appeal has never been better.",
  position: "Local Resident",
  neighborhood: "Monroeville"
}];
export default function VoiceOfTheClient() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="11814" id="why-neighbors-choose-us" ref={ref} className="relative w-full py-24 overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.03] select-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/pipecraft_watermark_logo.png" alt="Nieser Landscaping Watermark" className="w-[80vw] max-w-4xl h-auto object-contain grayscale" />
      </div>

      <div className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-primary font-serif mb-4">
            Why Neighbors Choose Us
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Trusted by Pittsburgh families for over 40 years. See what your
            neighbors are saying about our professional landscaping services.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4">
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <div className="h-full p-1">
                  <Card className="h-full border-border/40 bg-card/40 backdrop-blur-md shadow-lg hover:shadow-xl transition-shadow duration-500 rounded-lg border-l-4 border-l-primary border-y-0 border-r-0">
                    <CardContent className="flex flex-col justify-between h-full p-8 gap-6">
                      <div>
                        <div className="flex justify-between items-start mb-6">
                          <Quote className="size-8 text-primary/30 fill-primary/10" />
                          <Badge variant="secondary" className="gap-1 bg-accent/20 text-accent font-medium px-3 py-1 border-none">
                            <div className="flex gap-0.5">
                              {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-3 fill-accent text-accent" />)}
                            </div>
                          </Badge>
                        </div>
                        <blockquote className="text-xl font-medium italic text-foreground/90 font-serif leading-relaxed">
                          &ldquo;{testimonial.quote}&rdquo;
                        </blockquote>
                      </div>

                      <div className="pt-6 border-t border-border/20 mt-auto">
                        <div className="font-semibold text-foreground font-sans tracking-wide">
                          {testimonial.author}
                        </div>
                        <div className="text-sm text-muted-foreground flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 font-sans">
                          <span>{testimonial.position}</span>
                          <span className="hidden sm:inline text-border/50">
                            |
                          </span>
                          <span className="text-primary/90 font-bold text-xs uppercase tracking-widest">
                            {testimonial.neighborhood}
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <div className="flex justify-end gap-2 mt-8 pr-4">
            <CarouselPrevious className="static translate-y-0 translate-x-0 hover:bg-primary hover:text-primary-foreground border-primary/30 text-primary" />
            <CarouselNext className="static translate-y-0 translate-x-0 hover:bg-primary hover:text-primary-foreground border-primary/30 text-primary" />
          </div>
        </Carousel>
      </div>
    </section>;
}